import { render, staticRenderFns } from "./RemindAR.vue?vue&type=template&id=5935bf59"
import script from "./RemindAR.vue?vue&type=script&lang=js"
export * from "./RemindAR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports